/* Original Hellsewn route menu. Eye updates run only for visible, open menus. */
if (!customElements.get('hellsewn-route-map')) {
  customElements.define('hellsewn-route-map', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.menu = this.closest('[data-hellsewn-routes]');
      this.pupil = this.querySelector('[data-route-pupil]');
      this.eye = this.querySelector('[data-route-eye]');
      this.button = this.menu.querySelector('[data-route-motion]');
      this.media = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.paused = false;
      this.frame = 0;
      this.button.hidden = this.dataset.eyeEnabled !== 'true';
      this.updateMotion = () => {
        this.active = this.menu.dataset.navOpen === 'true' && this.visible && !document.hidden && !this.media.matches && !this.paused && this.dataset.eyeEnabled === 'true';
        this.dataset.animate = String(this.active);
        this.button.disabled = this.media.matches;
        this.button.textContent = this.media.matches ? 'Reduced motion enabled' : this.paused ? 'Resume eye animation' : 'Pause eye animation';
        this.button.setAttribute('aria-pressed', String(this.paused || this.media.matches));
        if (!this.active) {
          cancelAnimationFrame(this.frame);
          this.frame = 0;
          this.pupil.style.removeProperty('--eye-x');
          this.pupil.style.removeProperty('--eye-y');
        }
      };
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.updateMotion();
      });
      this.observer.observe(this);
      this.menu.addEventListener('hellsewn:nav', this.updateMotion, options);
      this.media.addEventListener('change', this.updateMotion, options);
      document.addEventListener('visibilitychange', this.updateMotion, options);
      this.button.addEventListener('click', () => { this.paused = !this.paused; this.updateMotion(); }, options);
      document.addEventListener('pointermove', event => {
        if (!this.active || !['mouse', 'pen'].includes(event.pointerType)) return;
        this.pointer = { x: event.clientX, y: event.clientY };
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (!this.active) return;
          const bounds = this.getBoundingClientRect();
          const eyeX = bounds.left + bounds.width * .5;
          const eyeY = bounds.top + bounds.height * 302 / 600;
          const dx = this.pointer.x - eyeX;
          const dy = this.pointer.y - eyeY;
          const distance = Math.hypot(dx, dy) || 1;
          const strength = Math.min(distance / 150, 1);
          this.pupil.style.setProperty('--eye-x', `${(dx / distance * 11 * strength).toFixed(2)}px`);
          this.pupil.style.setProperty('--eye-y', `${(dy / distance * 5 * strength).toFixed(2)}px`);
        });
      }, options);
      this.querySelectorAll('[data-route]').forEach(link => {
        const select = () => { this.dataset.selected = link.dataset.route; };
        const clear = () => {
          const focused = this.querySelector('[data-route]:focus');
          this.dataset.selected = focused?.dataset.route || '';
        };
        link.addEventListener('pointerenter', select, options);
        link.addEventListener('focus', select, options);
        link.addEventListener('pointerleave', clear, options);
        link.addEventListener('blur', () => { this.dataset.selected = ''; }, options);
        link.addEventListener('click', () => { this.dataset.selected = ''; }, options);
      });
      this.updateMotion();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
